import { render } from "./PriceTableCatalogue.vue?vue&type=template&id=0c044819&scoped=true&ts=true"
import script from "./PriceTableCatalogue.vue?vue&type=script&lang=ts"
export * from "./PriceTableCatalogue.vue?vue&type=script&lang=ts"

import "./PriceTableCatalogue.vue?vue&type=style&index=0&id=0c044819&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c044819"]])

export default __exports__